import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { jsPDF } from "jspdf";
import { Download } from "lucide-react";

export function PricelistQRSection() {
  const qrRef = useRef(null);
  const qrUrl = `${window.location.origin}/getraenkekarte`;

  const downloadPDF = () => {
    const canvas = qrRef.current?.querySelector("canvas");
    if (!canvas) return;
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const cols = 4, rows = 6;
    const pageW = 210, pageH = 297;
    const cellW = pageW / cols;
    const cellH = pageH / rows;
    const qrSize = 36;
    const labelH = 5;

    pdf.setFont("helvetica", "bold");
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        const cx = c * cellW + cellW / 2;
        const cy = r * cellH + cellH / 2 - labelH / 2;
        pdf.addImage(imgData, "PNG", cx - qrSize / 2, cy - qrSize / 2, qrSize, qrSize);
        pdf.setFontSize(7);
        pdf.text("Ninersbillard", cx, cy + qrSize / 2 + 3, { align: "center" });
        pdf.setFontSize(6);
        pdf.text("Getränkekarte", cx, cy + qrSize / 2 + 6.5, { align: "center" });
      }
    }
    pdf.save("getraenkekarte-qr-codes.pdf");
  };

  return (
    <div className="bg-card border border-white/5 p-5 mb-6 flex flex-col sm:flex-row items-start sm:items-center gap-5" data-testid="pricelist-qr-section">
      <div ref={qrRef} className="flex-shrink-0">
        <QRCodeCanvas value={qrUrl} size={120} bgColor="#ffffff" fgColor="#000000" level="M" includeMargin />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-bold uppercase tracking-wider mb-1" style={{ fontFamily: 'Oswald', color: '#fbbf24' }}>
          Getränkekarte QR-Code
        </h3>
        <p className="text-xs text-muted-foreground mb-1 break-all">{qrUrl}</p>
        <p className="text-xs text-muted-foreground mb-3">Gäste scannen diesen Code und gelangen direkt zur Getränkekarte.</p>
        <button onClick={downloadPDF} data-testid="download-qr-pdf-btn"
          className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground text-xs font-bold uppercase hover:-translate-y-0.5 transition-transform duration-200">
          <Download className="w-4 h-4" /> PDF herunterladen (A4, 4×6)
        </button>
      </div>
    </div>
  );
}
